const DbData = {

    "countries": {
        "russia": [
            {
                "id": "1",
                "country":"Russia",
                "backgroundurl": "https://www.mbbsinabroad.com/images/russia/altai-state-medical-university/2.jpg",
                "url1":"https://www.pngkit.com/png/full/254-2543504_doctors-getting-into-medical-school-the-premedical-students.png",
                "name": "Altai State Medical University",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "Russia is known worldwide for its academic excellence in higher studies. over 2 million students are enrolled in Russian Universities and institutes.Nearly 875000 science students and over tutes These students actively participate in exploring advanced technology and new scientific methods Russian medical institutes are well equipped with advanced technologies and adopt latest teaching methods. The Medical degrees granted by Russian medical colleges have grapped nearly 30 top position within the world ranking."
                },
                "brief":{
                    "capital":"Moscow",
                    "population":"14.41 crore(2020)",
                    "medium":"English",
                    "currency":"Russian Ruble(1 lari=1.37 inr)",
                    "currency_short":"ruble",
                    "in_airport":"Moscow",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"20-25 lakhs (Approx)",
                    "intake":"October",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":"Yes"
                },
                "table":{
                    "tution_fee":"3,23,600",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "5 years of total academic term",
                    "1 year of internship at renowned hospitals those are affiliated to individual university. (There are some universities which offers 3 years of internships)",
                    "Five valuable years of your academics in MBBS abroad Ukraine gives you the right amount of exposure."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Process of admissions in Medical universities in Ukraine usually starts after the entrance exams",
                    "Classes of MBBS study in Ukraine starts from the first week of September.",
                    "There are limited seats available in MBBS universities in Ukraine as the students apply from all over the world.",
                    "The seats are specified based on first come first serve.",
                    "Most students make their minds after the entrance exam. It is better to apply in the middle of July or August to get into Top 10 medical colleges in Ukraine.",
                    "We suggest you to gather knowledge about the NMC approved list of Ukrainian universities on their website. You can always enquire your questions in their official chat support."
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets"
                ],
            },
            {
                "id": "2",
                "backgroundurl": "https://www.edufever.com/wp-content/uploads/2022/10/Bashkir-State-Medical-University-Russia-jpg.webp",
                "name": "Bashkir State Medical University"
            },
            {
                "id": "3",
                "backgroundurl": "https://images.shiksha.com/mediadata/images/1593504342phpJnZSyT_g.jpg",
                "name": "Chuvash State University"
            },
            {
                "id": "4",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/01/Crimea-Federal-University.webp",
                "name": "Crimean Federal Medical University"
            },
            {
                "id": "5",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/01/I.-M.-Sechenov-First-Moscow-State-Medical-University.webp",
                "name": "First Moscow State Medical University"
            },
            {
                "id": "6",
                "backgroundurl": "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Far_Eastern_Federal_University_2.JPG/1200px-Far_Eastern_Federal_University_2.JPG",
                "name": "Far Eastern Federal University"
            },
            {
                "id": "7",
                "backgroundurl": "https://upload.wikimedia.org/wikipedia/commons/8/81/Kazan_Federal_University_building_08-2016.jpg",
                "name": "Kazan Federal University"
            },
            {
                "id": "8",
                "backgroundurl": "https://studymbbsinrussia.co.in/wp-content/uploads/2016/04/kazan-medical-university-russia.jpg",
                "name": "Kazan State Medical University"
            },
            {
                "id": "9",
                "backgroundurl": "https://foreignstudies.org/wp-content/uploads/2020/06/study-in-KUBAN-STATE-MEDICAL-UNIVERSITY-KRASNODAR.jpeg",
                "name": "Kuban State Medical University"
            },
            {
                "id": "10",
                "backgroundurl": "https://studymbbsinrussia.co.in/wp-content/uploads/2019/03/ksmu-kursk-russia.jpg",
                "name": "Kursk State Medical University"
            },
            {
                "id": "11",
                "backgroundurl": "https://www.mbbsuniversities.com/files/catalog/mari_state_uni1_2.jpg",
                "name": "Mari State University"
            },
            {
                "id": "12",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2020/11/Orenburg-State-Medical-University.webp",
                "name": "Orenburg State Medical University"
            },
            {
                "id": "13",
                "backgroundurl": "https://studymbbsinrussia.co.in/wp-content/uploads/2017/03/peoples-friendship-university-300x168.jpg",
                "name": "Peoples Friendship University"
            },
            {
                "id": "14",
                "backgroundurl": "https://images.shiksha.com/mediadata/images/1595599084phpRaENib.jpeg",
                "name": "Perm State Medical University"
            },
            {
                "id": "15",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/01/Pirogov-Russian-National-Research-Medical-University.webp",
                "name": "Pirogrod Russian National Research Medical University"
            },
            {
                "id": "16",
                "backgroundurl": "https://nixstudyabroad.com/wp-content/uploads/2022/01/rostov-state-medical-university.jpg",
                "name": "Rostov State Medical University"
            },
            {
                "id": "17",
                "backgroundurl": "https://www.rusvuz.com/wp-content/uploads/2020/05/Saint-Petersburg-State-Medical-University-Pavlov.jpg",
                "name": "Saint Petersburg State Medical University"
            },
            {
                "id": "18",
                "backgroundurl": "https://smolensk.in/wp-content/uploads/2022/05/slider2.jpg",
                "name": "Smolensk State Medical University"
            },
            {
                "id": "19",
                "backgroundurl": "https://ik.imagekit.io/lyzj6ywpw/main-images/tver-state-medical-university/image1.jpg",
                "name": "Tver State Medical University"
            },
            {
                "id": "20",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/01/Volgograd-State-Medical-University-2.webp",
                "name": "Volgograd State Medical University"
            },
            {
                "id": "21",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/01/Siberian-State-Medical-University.webp",
                "name": "Siberian State Medical University"
            },
            {
                "id": "22",
                "backgroundurl": "https://blog.rmgoe.org/wp-content/uploads/2023/05/South-Ural-State-Medical-University-Russia-1.jpg",
                "name": "South Ural State Medical University"
            },
            {
                "id": "23",
                "backgroundurl": "https://hedclub.com/data/pub/373/q5eLggKV28ga0ur_0AkS.jpg",
                "name": "Kemerovo State University"
            },
            {
                "id": "24",
                "backgroundurl": "https://www.edufever.com/wp-content/uploads/2021/06/Kemerovo-State-Medical-University-Russia-1-jpg.webp",
                "name": "Kemerovo State Medical University"
            },
            {
                "id": "25",
                "backgroundurl": "https://studymbbsinrussia.co.in/wp-content/uploads/2020/10/Main-Bulding-Kabardino-Balkarian-University.jpg",
                "name": "Kabardino Balkarian State Medical University"
            },
            {
                "id": "26",
                "backgroundurl": "https://edufever.in/colleges/wp-content/uploads/2022/10/North-Caucasian-State-Medical-Academy.webp",
                "name": "North Caucasian State Medical Academy"
            },
            {
                "id": "27",
                "backgroundurl": "https://studymbbsinrussia.co.in/wp-content/uploads/2014/06/Orel.jpg",
                "name": "Orel State Medical University"
            },
            {
                "id": "28",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/08/samara-state-medical-university-banner.webp",
                "name": "Samara State Medical University"
            }
        ],
        "germany": [
            {
                "id": "29",
                "country":"germany",
                "backgroundurl": "https://images.collegedunia.com/public/college_data/images/studyabroad/appImage/college_690_14-16:11_cov.jpeg?h=185&w=375&mode=stretch",
                "name": "Ludwig Maxmilian-Universitat Munchen",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "MBBS in Germany is very famous among Indian students. For every individual, Germany is becoming very popular because of its low-cost education. It is not completely free but the fee structure is comparatively low. MBBS from Germany has become a top choice in the last few years. It also includes the learning German language also with qualified lectures. It offers a very wide variety of programs for local and international students. "
                },
                "brief":{
                    "capital":"Berlin",
                    "population":"8.32 crores(2021)",
                    "medium":"English",
                    "currency":"Euro(1 Euro=90.27 INR)",
                    "currency_short":"Euro",
                    "in_airport":"MBerlin",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"20-25 lakhs (Approx)",
                    "intake":"",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":"Yes"
                },
                "table":{
                    "tution_fee":"3,23,600",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "The total duration for completing the MBBS/MD in Germany from the best universities is 7.5 years. Some colleges with economical fee structure don’t follow this system. The time required is the same as in Russia and Germany. The MBBS course duration is 6 years. After MBBS, lots of students opt for PG in Germany. It is a new trend and good for fast career growth."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Fill the application form of the different medical universities from which you want to do MBBS.",
                    "Upload the required documents including academic certificates, German and English language proficiency certificate, passport, and other demanded documents.",
                    "Wait for the confirmation sent from an institution shortlisting your application form.",
                    "When an offer letter comes to you, you must save it for the future.",
                    "Pay the University and enrolment fees.",
                    "When the fees process is completed, then go for the VISA.",
                    "Get all your documents checked, validated, and authenticated prior to VISA application Visit German Embassy in Delhi after you receive the Invitation Letter",
                    "Proof of strong financial need to be shown to support your medical education in Germany",
                    "Get a VISA for Germany then book a flight ticket for there."
                ],
                "eligibility":[
                    "Indian students who have passed 12th in the mainstream Biology can apply for MBBS in Germany.",
                    "The students who have achieved 60% or more than 60% in Physics, Chemistry, and Biology are preferred.",
                    "He/she should have completed 17 years of age.",
                    "TOEFL & IELTS score is necessary.",
                    "One needs to clear TestDaf test",
                    "Certificate of passing DSH (Deutsche Sprachprufung fur den Hochschulzugang) or other German language test like GDS and KDS is mandatory",
                    "The minimum C1 level is required however, B2 level in German language is generally demanded",
                    "If a student takes the preparatory course, B1 German Certificate is essential.",
                    "Your documents should be checked by German Academic Exchange Service (DAAD) to verify if your academic qualifications are accredited and recognized. Also, to check if it meets the German medical school set necessary standards.",
                    "Students may be required to appear for certain entrance tests",
                    "The applicant should have a valid passport copy.",
                    "The applicant should be medically fit for MBBS studies.",
                    "The applicant should have cleared NEET with the minimum allowed score."
                ],
                "documents":[
                    "Passport (18 Months Validity)",
                    "10th certificate and marksheet",
                    "12th certificate and mark sheet",
                    "1st Year graduation marksheet",
                    "All the documents need to be attested by a Gazetted Officer",
                    "Birth certificate",
                    "10 passport size photos",
                    "German and English language proficiency proof",
                    "Recommendation letters",
                    "Offer letter of the desired Medical University of Germany",
                    "Authorization of all documents from the ministry of external affairs, New Delhi",
                    "Legalization of all the documents from the German Embassy",
                    "Visa Fees",
                    "Bank - Receipt of University first-year tuition fee",
                    "Medical NEET passing documents"
                ],
            },
            {
                "id": "30",
                "backgroundurl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Berlin-Mitte_Bebelplatz1_05-2014.jpg/533px-Berlin-Mitte_Bebelplatz1_05-2014.jpg",
                "name": "Humboldt-Universitat zu Berlin"
            },
            {
                "id": "31",
                "backgroundurl": "https://a.travel-assets.com/findyours-php/viewfinder/images/res70/346000/346837-Universitatsbibliothek.jpg",
                "name": "Universitat Heidelberg"
            },
            {
                "id": "32",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Freie Universitat Berlin"
            }
        ],
        "kazakhstan": [
            {
                "id": "33",
                "country":"Kazakhstan",
                "backgroundurl": "https://www.tutelagestudy.com/uploads/university/IMG_20221215_172408.jpg",
                "name": "Al-Farebi National University",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "The MBBS in Kazakhstan is a very well-known course to all the medical aspirants as all top medical colleges in Kazakhstan is recognized by WHO, USMLE, IMED GMC, and NMC. Many well-known universities here are offering MBBS in Kazakhstan for Indian Students to achieve their dreams. You can find one of the best MBBS Universities in Kazakhstan. More than 5,000 Indian students come here every year and more than 60, 000 medical students to get their medical degree. And that’s why Kazakhstan is the #1 national medical university."
                },
                "brief":{
                    "capital":"Nur-Sultan",
                    "population":"1.88 crores(2020)",
                    "medium":"English",
                    "currency":"Kazakhstani Tenge(1Tenge=0.17 inr)",
                    "currency_short":"Tenge",
                    "in_airport":"Almaty",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"15-25 lakhs(Approx)",
                    "intake":"Summer & Winter",
                    "score_required":"50% in PCB",
                    "hostel":"Hostel & Apartment",
                    "neet_req":""
                },
                "table":{
                    "tution_fee":"3700$-4600$",
                    "hostal_fee":"500$-2000$",
                    "otc":"2000$-2500$",
                    "incentive":"800$-1000$"
                },
                "duration":[
                    "The duration of MBBS courses in Kazakhstan is 5 years in whole",
                    "The candidates need to study for another 1 years for the internship",
                    "It will take 4 years to complete clinical studies in MBBS Courses in Kazakhstan."
                ],
                "medium_teaching":[
                    "The students are taught local languages also",
                    "It helps the students to communicate with the locals during the internship program"
                ],
                "intake":[
                    "Generally, most of the universities closed their admission process of MBBS Courses in Kazakhstan within 15th of July",
                    "Therefore, it will be better for the MBBS seekers to apply MBBS admission within June.",
                    "Generally, the classes of MBBS start from August to September in Medical education in Kazakhstan."
                ],
                "eligibility":[
                    "The age of the candidates must be 17 years",
                    "The candidates must clear 10+2 examination",
                    "It is necessary for the medical aspirants to secure 50 % marks in the 12th examination",
                    "The subject combination should be Chemistry, Physics and Math for MBBS Seat in Kazakhstan",
                    "As per the requirements of Kazakhstan universities, the candidates must qualify NEET-UG",
                    "It is mandatory for the candidates to have valid passport to study Medicine in Kazakhstan",
                    "As per the rules of NMC, the ST/SC/OBC candidates need to score at least 40 % marks in the same"
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets",
                    "You need to carry student visa",
                    "No Objection Certificate is required for the submission"
                ],
            },
            {
                "id": "34",
                "backgroundurl": "https://www.astanamedicaluniversity.com/wp-content/uploads/2016/03/1454643778.1564.jpg",
                "name": "Astana Medical University"
            },
            {
                "id": "35",
                "backgroundurl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Main_building%2C_Kazak_National_Medical_University.jpg/640px-Main_building%2C_Kazak_National_Medical_University.jpg",
                "name": "Kazakh National University"
            },
            {
                "id": "36",
                "backgroundurl": "https://www.moksh16.com/uploads/images/Kazakhstan/kaz-2023.webp",
                "name": "Kokshetau State University"
            },
            {
                "id": "37",
                "backgroundurl": "https://www.mbbsuniversities.com/files/catalog/m_uni1_1.jpg",
                "name": "North Kazakhstan state University"
            },
            {
                "id": "38",
                "backgroundurl": "https://bosonmeditech.com/wp-content/uploads/2022/04/Semey-State-Medical-University-ranking-fees.jpg",
                "name": "Semey State Medical University"
            },
            {
                "id": "39",
                "backgroundurl": "https://admissionroute.com/wp-content/uploads/2022/03/South-Kazakhstan-Medical-Academy.jpg",
                "name": "South Kazakhstan Medical Academy"
            },
            {
                "id": "40",
                "backgroundurl": "https://www.worldwidecolleges.com/wp-content/uploads/classified-listing/2023/04/6-1-1.jpg",
                "name": "UIB International Medical School in Almaty"
            },
            {
                "id": "41",
                "backgroundurl": "https://www.tutelagestudy.com/uploads/university/IMG_20221216_172506.jpg",
                "name": "West Kazakhstan Medical University"
            }
        ],
        "georgia": [
            {
                "id": "42",
                "country":"Georgia",
                "backgroundurl": "https://www.moksh16.com/uploads/images/alte-university-school-of-medicine-georgia/alte-university-school-of-medicine-georgia.webp",
                "name": "Alte University",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "MBBS in Georgia is one of the famous places to pursue a career in MBBS. It is the most preferred destination for all the aspiring medical students. MBBS universities in GEORGIA provides the best facilities for all the medical students and also allows who hasn’t passed the test of 2 languages (IELTS + TOEFL). The country is very much liberating in these cases. MBBS IN GEORGIA is a platform where medical students can ensure themselves to get a high-paying job in some top medical farms and hospitals throughout the whole world. Students who want to study MBBS IN GEORGIA and also have 50% marks can apply for the Scholarship."
                },
                "brief":{
                    "capital":"Tbilisi",
                    "population":"37.1 Lakhs(2020)",
                    "medium":"English",
                    "currency":"Georgian Lari(1 Lari= 27.00 inr)",
                    "currency_short":"Lari",
                    "in_airport":"Tbilisi",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"20-25 lakhs (Approx)",
                    "intake":"Summer & Winter",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":"Yes"
                },
                "table":{
                    "tution_fee":"3,23,600",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "5 years of total academic term",
                    "1 year of internship at renowned hospitals those are affiliated to individual university. (There are some universities which offers 3 years of internships)",
                    "Five valuable years of your academics in MBBS abroad Ukraine gives you the right amount of exposure."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Process of admissions in Medical universities in Ukraine usually starts after the entrance exams",
                    "Classes of MBBS study in Ukraine starts from the first week of September.",
                    "There are limited seats available in MBBS universities in Ukraine as the students apply from all over the world.",
                    "The seats are specified based on first come first serve.",
                    "Most students make their minds after the entrance exam. It is better to apply in the middle of July or August to get into Top 10 medical colleges in Ukraine.",
                    "We suggest you to gather knowledge about the NMC approved list of Ukrainian universities on their website. You can always enquire your questions in their official chat support."
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets",
                   " You need to carry student visa",
                    "No Objection Certificate is required for the submission"
                ],
            },
            {
                "id": "43",
                "backgroundurl": "https://mbbsingeorgia.net/images/akaki-tsereteli-state-university.webp",
                "name": "Akaki Tsereteli State University"
            },
            {
                "id": "44",
                "backgroundurl": "https://www.worldwidecolleges.com/wp-content/uploads/classified-listing/2023/04/120955240_106304614584976_4866886480323996069_n.jpg",
                "name": "Batumi Shota Rustaveli State University"
            },
            {
                "id": "45",
                "backgroundurl": "https://www.mbbsinabroad.com/images/georgia-university/bau-international-university-batumi/1.jpg",
                "name": "BAU International University, Batumi"
            },
            {
                "id": "46",
                "backgroundurl": "https://www.riaoverseas.com/wp-content/uploads/2020/04/caucasus-6-1024x683-1.jpg",
                "name": "Caucasus University"
            },
            {
                "id": "47",
                "backgroundurl": "https://lh3.googleusercontent.com/proxy/kiopK1aq0NU09BuPfbE71gjVlkVdDOebEhqlPY1GcGpi2qxuEvXjEk6vP4yWJHqU5H-u0MASXr28gkMOlKIG6rNxhLz5A64jlmct_pgX8Fh7VhxiErog-YVDYgFqkUCirsDpmyimkjkp7dHWTKW71qzffnBr1g",
                "name": "Caucasus International University"
            },
            {
                "id": "48",
                "backgroundurl": "https://www.moksh16.com/uploads/images/David%20Tvildiani%20Medical%20University/untitled-2.jpg",
                "name": "David Tvildiani Medical University"
            },
            {
                "id": "49",
                "backgroundurl": "https://www.ismedutechcg.com/wp-content/uploads/2021/10/east-european-university.jpg",
                "name": "East European University"
            },
            {
                "id": "50",
                "backgroundurl": "https://www.medicalabroad.org/wp-content/uploads/2016/06/Campus-View.jpg",
                "name": "European University"
            }
            ,
            {
                "id": "51",
                "backgroundurl": "https://www.gkworks.in/wp-content/uploads/2023/04/GNU.jpg",
                "name": "Georgian National University SEU"
            }
            ,
            {
                "id": "52",
                "backgroundurl": "https://www.mbbsneet.com/wp-content/uploads/2017/08/geomedi.jpg",
                "name": "Geomedi Medical University"
            }
            ,
            {
                "id": "53",
                "backgroundurl": "https://eoestudyoverseas.com/wp-content/uploads/2020/08/Gruni-1-1024x493.png",
                "name": "Grigol Robakidze University"
            }
            ,
            {
                "id": "54",
                "backgroundurl": "https://admissionoffice.ge/wp-content/uploads/2019/04/georgian-american-university-gau-tbilisi-logo-georgia-country-caucasus-europe.jpg",
                "name": "Georgian American University"
            }
            ,
            {
                "id": "55",
                "backgroundurl": "https://www.topmbbsabroad.com/assets/trueimage/tsu.jpg",
                "name": "lvane Javakhishvili Tbilisi State University"
            }
            ,
            {
                "id": "56",
                "backgroundurl": "https://www.medlinkstudents.com/wp-content/uploads/2021/06/Ilia-State-University.jpg",
                "name": "Ilia State University"
            }
            ,
            {
                "id": "57",
                "backgroundurl": "https://navchetana.education/assets/images/universities/georgia/kutaisi-university.jpg",
                "name": "Kutaisi University"
            }
            ,
            {
                "id": "58",
                "backgroundurl": "https://mbbscouncilcdn.s3.amazonaws.com/wp-content/uploads/2019/01/New-Vision-University-Georgia-College.jpg",
                "name": "New Vision University"
            }
            ,
            {
                "id": "59",
                "backgroundurl": "https://static.wixstatic.com/media/9cdbfb_fc0f9b2863d94011976e7d88ca142f6a~mv2.jpg/v1/fill/w_2000,h_1000,al_c,q_90/The%20Petre%20Shotadze%20Tbilisi%20Medical%20Acade.jpg",
                "name": "Petre Shotadze Tbilisi Medical Academy"
            }
            ,
            {
                "id": "60",
                "backgroundurl": "https://www.edufever.com/wp-content/uploads/2021/12/Tbilisi-State-Medical-University-2-jpg.webp",
                "name": "Tbilisi State Medical University"
            }
            ,
            {
                "id": "61",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/01/University-of-Georgia.webp",
                "name": "University Of Georgia"
            }
        ],
        "poland": [
            {
                "id": "62",
                "country":"Poland",
                "backgroundurl": "https://www.mbbsuniversities.com/files/catalog/jagiellonian_uni1_1.jpg",
                "name": "Jagiellonian University Medical College",
                "header": {
                    "title": "Do you aspire to study MBBS in Poland? Are you looking for colleges of international repute to pursue medicine? Well, if you answer in positive, you must check out universities in Poland. Universities in Poland offer quality education at low-cost. The fee in the universities in Poland is low as compared to other European Countries. Therefore, it makes a great place for international students to study medicine. Poland has been the hubspot for Indians to study Medicine. MBBS in Poland is “The Dream” for many Indian students. Poland is also a part of EU which enables graduates to pursue MBBS in other European countries."
                },
                "brief":{
                    "capital":"	Warsaw",
                    "population":"16.94 crores (2021)",
                    "medium":"English",
                    "currency":"Polish Zloty (1 Polish Zloty= 19.73 INR)",
                    "currency_short":"ruble",
                    "in_airport":"Moscow",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"20-25 lakhs (Approx)",
                    "intake":"October",
                    "score_required":"75% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":"Yes"
                },
                "table":{
                    "tution_fee":"4200$",
                    "hostal_fee":"200 to 260 USD Per Month",
                    "otc":"",
                    "incentive":"YES"
                },
                "duration":[
                   " Polish Medical Universities offer 6 year courses in various specialities.",
                    "The students can pursue courses in Medicine, Nursing, Pharmacy and Dentistry",
                    "The courses offered to the student depend on the choice of the university",
                    "Every university in Poland feature 1 year of compulsory internship included in the 6-year course.",
                   " Indian students can choose NMC approved universities in Poland"
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "The students interested to pursue MBBS Poland must prepare in advance for the admissions",
                    "The universities in Poland open admission in the month of April each year",
                    "The deadline for application in the colleges for MBBS in Poland falls in the middle of October"
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets"
                ],
            },
            {
                "id": "63",
                "backgroundurl": "https://sustainabledrugdiscovery.eu/wp-content/uploads/brizy/imgs/Picture1-658x329x110x0x438x329x1639978283.jpg",
                "name": "Medical University Of Gdansk"
            },
            {
                "id": "64",
                "backgroundurl": "https://www.euromed-f.com/wp-content/uploads/2016/07/bol-19.jpg",
                "name": "Medical University Of Lodz"
            },
            {
                "id": "65",
                "backgroundurl": "https://study.gov.pl/sites/default/files/styles/wiz/public/foto_ucz_wiz/1/universum_93.jpg?itok=H8OY5tG1",
                "name": "Medical University Of Lublin"
            },
            {
                "id": "66",
                "backgroundurl": "https://www.mbbsuniversities.com/files/catalog/nicolaus_uni1_2.jpg",
                "name": "Nicolaus Copernicus University"
            },
            {
                "id": "67",
                "backgroundurl": "https://ex2zh3hpqb4.exactdn.com/wp-content/uploads/2019/03/Poznan-University-of-Medical-Sciences.jpg?strip=all&lossy=1&ssl=1&fit=1082,386",
                "name": "Poznan Medical University"
            },
            {
                "id": "68",
                "backgroundurl": "https://c8.alamy.com/comp/PXEEBX/katowice-poland-the-university-of-silesia-in-katowice-faculty-of-mathematics-PXEEBX.jpg",
                "name": "University Of Silesia"
            },
            {
                "id": "69",
                "backgroundurl": "https://www.medlinkstudents.com/wp-content/uploads/2021/04/Study-Medicine-at-University-of-Warmia-and-Mazury-in-Olsztyn-1.jpg",
                "name": "University Of Warmia And Mazury In Olsztyn"
            },
            {
                "id": "70",
                "backgroundurl": "https://images.shiksha.com/mediadata/images/1516343520php60r2kf.jpeg",
                "name": "University Of Wroclaw"
            },
            {
                "id": "71",
                "backgroundurl": "https://images.shiksha.com/mediadata/images/1598270607phpRivnmC.jpeg",
                "name": "Warsaw Medical Academy"
            }
        ],
        "moldova": [
            {
                "id": "72",
                "country":"Moldova",
                "backgroundurl": "https://luminisabroad.com/wp-content/uploads/2022/08/slider3.jpg",
                "name": "Nicole Testemitanu state University of Medicine and Pharmacy",
                "header": {
                    "title": "Moldova oficially the Republic of Moldova (Romanian :Republica Moldova),is a land-locked country in Eastern Europe . It is bordered by Romania to the west and Ukraine to the north , east, and south . The Unrecognised state of Transnistria lies across the Dnies-ter river on the country's eastern border with Ukraine. Moldova's capital and largest city is Chisinau."
                },
                "brief":{
                    "capital":"Chisinau",
                    "population":"14.41 crore(2020)",
                    "medium":"English",
                    "currency":"Russian Ruble(1 lari=1.37 inr)",
                    "currency_short":"ruble",
                    "in_airport":"Moscow",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"20-25 lakhs (Approx)",
                    "intake":"Summer & Winter",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":""
                },
                "table":{
                    "tution_fee":"5000 Euro",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "5 years of total academic term",
                    "1 year of internship at renowned hospitals those are affiliated to individual university. (There are some universities which offers 3 years of internships)",
                    "Five valuable years of your academics in MBBS abroad Ukraine gives you the right amount of exposure."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Process of admissions in Medical universities in Ukraine usually starts after the entrance exams",
                    "Classes of MBBS study in Ukraine starts from the first week of September.",
                    "There are limited seats available in MBBS universities in Ukraine as the students apply from all over the world.",
                    "The seats are specified based on first come first serve.",
                    "Most students make their minds after the entrance exam. It is better to apply in the middle of July or August to get into Top 10 medical colleges in Ukraine.",
                    "We suggest you to gather knowledge about the NMC approved list of Ukrainian universities on their website. You can always enquire your questions in their official chat support."
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets"
                ],
            }
        ],
        "serbia": [
            {
                "id": "73",
                "country":"Serbia",
                "backgroundurl": "https://www.moksh16.com/uploads/images/Serbia/University-of-Kragujevac.webp",
                "name": "University of Kraguyievac",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "Serbia officially the Republic of serbia is a landlocked country in southeastern and central Europe , situated at the crossroads of the pannonian Basin and the Balkans . It shares land border with Hungary to the north ,Romania to the northeast , Bulgaria to the south east , North Macedonia to the south , croatia and Bosnia and Herzegovina to the west and montenegro to the southwest , and claims a border with Albania through the disputed territory of kosovo Serbia without kosovo has about 6.7 million inhabitants , about 8.4 millions if kosovo is included. its capital Belgrade is also the largest city."
                },
                "brief":{
                    "capital":"Belgrade",
                    "population":"68.3lakh9(2021)",
                    "medium":"English",
                    "currency":"Serbian Dinar(1 serbian Dinar 0.77 INR)",
                    "currency_short":"Dinar",
                    "in_airport":"Belgrade",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"20-25 lakhs (Approx)",
                    "intake":"October",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":""
                },
                "table":{
                    "tution_fee":"3,23,600",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "5 years of total academic term",
                    "1 year of internship at renowned hospitals those are affiliated to individual university. (There are some universities which offers 3 years of internships)",
                    "Five valuable years of your academics in MBBS abroad Ukraine gives you the right amount of exposure."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Process of admissions in Medical universities in Ukraine usually starts after the entrance exams",
                    "Classes of MBBS study in Ukraine starts from the first week of September.",
                    "There are limited seats available in MBBS universities in Ukraine as the students apply from all over the world.",
                    "The seats are specified based on first come first serve.",
                    "Most students make their minds after the entrance exam. It is better to apply in the middle of July or August to get into Top 10 medical colleges in Ukraine.",
                    "We suggest you to gather knowledge about the NMC approved list of Ukrainian universities on their website. You can always enquire your questions in their official chat support."
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets"
                ],
            },
            {
                "id": "74",
                "backgroundurl": "https://media.licdn.com/dms/image/C561BAQE_T7rFM-f0lQ/company-background_10000/0/1583926076889?e=2147483647&v=beta&t=ZkwI7ocmd9ixbHtCTHLEgzoJ345iU09QydEfPsgh-wY",
                "name": "University of Nis"
            },
            {
                "id": "75",
                "backgroundurl": "https://upload.wikimedia.org/wikipedia/commons/8/8c/%D0%A1%D0%B2%D1%98%D0%B5%D1%82%D0%BB%D0%BE%D0%BF%D0%B8%D1%81_%D0%B7%D0%B3%D1%80%D0%B0%D0%B4%D0%B5_%D0%9F%D1%80%D0%B0%D0%B2%D0%BD%D0%BE%D0%B3_%D1%84%D0%B0%D0%BA%D1%83%D0%BB%D1%82%D0%B5%D1%82%D0%B0_%D1%83_%D0%91%D0%B8%D0%BE%D0%B3%D1%80%D0%B0%D0%B4%D1%83.jpg",
                "name": "University of Belgrade"
            },
            {
                "id": "76",
                "backgroundurl": "https://image.free-apply.com/gallery/l/uni/gallery/lg/1068800011/34c724a04dbe42a3ccfa81950d6dc6591befb227.jpg?s=640",
                "name": "University of Novi sad"
            }
        ],
        "nepal": [
            {
                "id": "77",
                "country":"nepal",
                "backgroundurl": "https://www.besonline.in/blog/wp-content/uploads/2019/08/Iom.jpg",
                "name": "Institute Of Medicine (IOM)",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "Nestled Between the Majestic Himalayas . Nepal is Landlocked Between India and China ,Nar-rowly missing Bangladesh The Nation lies on the southern slopes of the mountanious Ranges of Himalayas."
                },
                "brief":{
                    "capital":"Kathmandu",
                    "population":"3 crores (2021)",
                    "medium":"English",
                    "currency":"Napalese Rupee (0.62 Indian Rupee)",
                    "currency_short":"Rupee",
                    "in_airport":"Tribhuvan",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"20-25 lakhs (Approx)",
                    "intake":"October",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":""
                },
                "table":{
                    "tution_fee":"3,23,600",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "5 years of total academic term",
                    "1 year of internship at renowned hospitals those are affiliated to individual university. (There are some universities which offers 3 years of internships)",
                    "Five valuable years of your academics in MBBS abroad Ukraine gives you the right amount of exposure."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Process of admissions in Medical universities in Ukraine usually starts after the entrance exams",
                    "Classes of MBBS study in Ukraine starts from the first week of September.",
                    "There are limited seats available in MBBS universities in Ukraine as the students apply from all over the world.",
                    "The seats are specified based on first come first serve.",
                    "Most students make their minds after the entrance exam. It is better to apply in the middle of July or August to get into Top 10 medical colleges in Ukraine.",
                    "We suggest you to gather knowledge about the NMC approved list of Ukrainian universities on their website. You can always enquire your questions in their official chat support."
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets"
                ],
            },
            {
                "id": "78",
                "backgroundurl": "https://www.bpkihs.edu/assets/images/bpkihs-cb.jpg",
                "name": "B.P Koirla Institute of Health Science (BPKIHS)"
            },
            {
                "id": "79",
                "backgroundurl": "https://careermudhra.com/wp-content/uploads/karnali-academy-of-health-sciences.jpg",
                "name": "Karnali Academy of Health Science ,Karnali"
            },
            {
                "id": "80",
                "backgroundurl": "https://www.abroadadvice.com/wp-content/uploads/2022/03/Patan-Academy-of-Health-Sciences-1.jpeg",
                "name": "Patan Academy of Health Science(PAHS),Patan"
            },
            {
                "id": "81",
                "backgroundurl": "https://www.worldwidecolleges.com/wp-content/uploads/classified-listing/2023/04/featured11.jpg",
                "name": "North Kazakhstan state University"
            },
            {
                "id": "82",
                "backgroundurl": "https://assets-api.kathmandupost.com/thumb.php?src=https://assets-cdn.kathmandupost.com/uploads/source/news/2016/miscellaneous/25092016091541nams1.jpg&w=900&height=601",
                "name": "National Academy of Medical Science(NAMS)"
            },
            {
                "id": "83",
                "backgroundurl": "https://argroupofeducation.com/wp-content/uploads/2023/09/Nepal-Army-Institute-of-Health-Sciences-Kathmandu.jpg",
                "name": "Nepalese Army Institute of Health Science"
            },
            {
                "id": "84",
                "backgroundurl": "https://www.edufever.com/wp-content/uploads/2021/06/Manipal-College-of-Medical-Sciences-Nepal-1-jpg.webp",
                "name": "Manipal Medical college of Medical science (MCOMS),Pokhra"
            },
            {
                "id": "85",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "college of Medical college ,Bharatpur"
            },
            {
                "id": "86",
                "backgroundurl": "https://www.justmbbs.com/img/college/nepal/kathmandu-university-school-of-medical-sciences-banner.jpg",
                "name": "Kathmandu school of Medical Science"
            },
            {
                "id": "87",
                "backgroundurl": "https://ucsworld.com/wp-content/uploads/2016/04/universal-medical-college.jpg",
                "name": "Nepal medical college ,jorputi ,Kathmandu"
            },
            {
                "id": "88",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Kathmandu Medical College,Kathmandu"
            },
            {
                "id": "89",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Birat Medical college ,Biratnagar"
            },
            {
                "id": "90",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Nepalgunj Medical college ,Nepalgunj"
            },
            {
                "id": "91",
                "backgroundurl": "https://www.riaoverseas.com/wp-content/uploads/2021/12/NEPALGUNJ-MEDICAL-COLLEGENEPALGUNJ.jpg",
                "name": "Lumbini medical college (LMC) , Tansen"
            },
            {
                "id": "92",
                "backgroundurl": "https://5.imimg.com/data5/SELLER/Default/2020/12/LU/FE/XC/119701179/nobel-medical-college-biratnagar.jpg",
                "name": "Nobel Medical college ,Biratnagar"
            },
            {
                "id": "93",
                "backgroundurl": "https://www.edufever.com/wp-content/uploads/2023/09/Devdaha-Medical-College-Nepal.webp",
                "name": "Devdaha Medical college & Teaching Hospital ,Devdaha"
            },
            {
                "id": "94",
                "backgroundurl": "https://gunagroups.com/wp-content/uploads/2018/02/kist-1.jpg",
                "name": "KST Medical college (KISTMCTH)"
            },
            {
                "id": "95",
                "backgroundurl": "https://5.imimg.com/data5/SELLER/Default/2023/6/317718564/YC/XH/GQ/119701179/chitwan-medical-college-nepal-1-.png",
                "name": "Chitwan Medical College (CMC), Bharatpur"
            },
            {
                "id": "96",
                "backgroundurl": "https://the-corporate.com/public/profile_images/55302-1632822234.jpg",
                "name": "Gandaki Medical college(GMCTHRC), Lekhnath"
            },
            {
                "id": "97",
                "backgroundurl": "https://mbbsinnepal.org/wp-content/uploads/2021/10/nmcb2.jpg",
                "name": "National Medical college(NMC), Birgunj"
            },
            {
                "id": "98",
                "backgroundurl": "https://college4u.in/wp-content/uploads/2018/07/univ.jpg",
                "name": "University Medicine College (UCMS), Bhairawaha"
            }

        ],
        "italy": [
            {
                "id": "99",
                "country":"Italy",
                "backgroundurl": "https://www.tutelagestudy.com/uploads/university/IMG_20221215_172408.jpg",
                "name": "Al-Farebi National University",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "Italy, officially the italian Republic or the Repubic of Italy is a country in southern and western europe . Located in the middle of the mediterra nean sea , it consists of a peninsula delimited by territory largely coincides with the homonymous geographical region. italy shares land border with France, Switzerland , Austria , slovenia .It is the third most populous country in Europen and the tenth largest country in the continent by land area."
                },
                "brief":{
                    "capital":"Rome",
                    "population":"5.91 crores (2021)",
                    "medium":"English",
                    "currency":"Euro(1Euro-90.26INR)",
                    "currency_short":"euro",
                    "in_airport":"Rome",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"20-25 lakhs (Approx)",
                    "intake":"October",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":"Yes"
                },
                "table":{
                    "tution_fee":"3,23,600",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "5 years of total academic term",
                    "1 year of internship at renowned hospitals those are affiliated to individual university. (There are some universities which offers 3 years of internships)",
                    "Five valuable years of your academics in MBBS abroad Ukraine gives you the right amount of exposure."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Process of admissions in Medical universities in Ukraine usually starts after the entrance exams",
                    "Classes of MBBS study in Ukraine starts from the first week of September.",
                    "There are limited seats available in MBBS universities in Ukraine as the students apply from all over the world.",
                    "The seats are specified based on first come first serve.",
                    "Most students make their minds after the entrance exam. It is better to apply in the middle of July or August to get into Top 10 medical colleges in Ukraine.",
                    "We suggest you to gather knowledge about the NMC approved list of Ukrainian universities on their website. You can always enquire your questions in their official chat support."
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets"
                ],
            },
            {
                "id": "100",
                "backgroundurl": "https://www.astanamedicaluniversity.com/wp-content/uploads/2016/03/1454643778.1564.jpg",
                "name": "Astana Medical University"
            },
            {
                "id": "101",
                "backgroundurl": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Main_building%2C_Kazak_National_Medical_University.jpg/640px-Main_building%2C_Kazak_National_Medical_University.jpg",
                "name": "Kazakh National University"
            },
            {
                "id": "102",
                "backgroundurl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ3DDmflRFSJSryXCCjzUr4obJO1jjtEOdGXA&usqp=CAU",
                "name": "Kokshetau State University"
            },
            {
                "id": "103",
                "backgroundurl": "https://studypalacehub.com/wp-content/uploads/2022/10/k7.png",
                "name": "North Kazakhstan state University"
            },
            {
                "id": "104",
                "backgroundurl": "https://smu.edu.kz/wp-content/uploads/2019/09/img_3489.jpg",
                "name": "Semey State Medical University"
            },
            {
                "id": "105",
                "backgroundurl": "https://www.admissionadvisor.org/images/south-kazakhstan-state-medical-academy1.jpg",
                "name": "South Kazakhstan Medical Academy"
            },
            {
                "id": "106",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "UIBb International Medical School in Almaty"
            },
            {
                "id": "107",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "West Kazakhstan Medical University"
            }
        ],
        "kyrgyzstan": [
            {
                "id": "108",
                "country":"Kyrgyzstan",
                "backgroundurl": "https://images.collegedunia.com/public/college_data/images/studyabroad/appImage/college_690_14-16:11_cov.jpeg?h=185&w=375&mode=stretch",
                "name": "Asian Medical Institute",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "MBBS in Kyrgyzstan is a golden opportunity for medical students who want to study abroad in a budget. To be a part of a well-known MBBS university in the world Medical Education in Kyrgyzstan is the best. Don’t miss out on the chance to study in universities that are approved by NMC & WHO with other bodies. According to Quora, there are more than 10,000 Indian students are studying in Kyrgyzstan."
                },
                "brief":{
                    "capital":"Bishkek",
                    "population":"65.9 lakhs(2020)",
                    "medium":"English",
                    "currency":"Kyrgyz (National/State language) Russian (Official and lnterethnic)",
                    "currency_short":"Kyrgyz",
                    "in_airport":"Bishkek",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"20-25 lakhs (Approx)",
                    "intake":"October",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":""
                },
                "table":{
                    "tution_fee":"3,23,600",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "5 years of total academic term",
                    "1 year of internship at renowned hospitals those are affiliated to individual university. (There are some universities which offers 3 years of internships)",
                    "Five valuable years of your academics in MBBS abroad Ukraine gives you the right amount of exposure."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Process of admissions in Medical universities in Ukraine usually starts after the entrance exams",
                    "Classes of MBBS study in Ukraine starts from the first week of September.",
                    "There are limited seats available in MBBS universities in Ukraine as the students apply from all over the world.",
                    "The seats are specified based on first come first serve.",
                    "Most students make their minds after the entrance exam. It is better to apply in the middle of July or August to get into Top 10 medical colleges in Ukraine.",
                    "We suggest you to gather knowledge about the NMC approved list of Ukrainian universities on their website. You can always enquire your questions in their official chat support."
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets"
                ],
            },
            {
                "id": "109",
                "backgroundurl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Berlin-Mitte_Bebelplatz1_05-2014.jpg/533px-Berlin-Mitte_Bebelplatz1_05-2014.jpg",
                "name": "Bishkek International Medical University"
            },
            {
                "id": "110",
                "backgroundurl": "https://a.travel-assets.com/findyours-php/viewfinder/images/res70/346000/346837-Universitatsbibliothek.jpg",
                "name": "International School of Medicine"
            },
            {
                "id": "111",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "International Medical University"
            },
            {
                "id": "112",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Jalal-Abad State Medical University"
            },
            {
                "id": "113",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Kyrgyz Russian Slavic University"
            },
            {
                "id": "114",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Kyrgyz State Medical Academy"
            },
            {
                "id": "115",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Osh State Medical University"
            }
        ],
        "uzbekistan": [
            {
                "id": "116",
                "country":"Uzbekistan",
                "backgroundurl": "https://images.collegedunia.com/public/college_data/images/studyabroad/appImage/college_690_14-16:11_cov.jpeg?h=185&w=375&mode=stretch",
                "name": "Andijan State Medical Institute",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "Studying MBBS in Uzbekistan currently turns into the ideal alternative for Indian students. It correlates with different medical examinations, experienced resources, looked after medical clinics, and phenomenal food quality. MBBS in Uzbekistan is a five years course and 100% English medium all through the five years. Medical schooling in Uzbekistan is excellent; it satisfies the worldwide guideline of instruction. From the previous years, there has been a tremendous tendency of students for studying MBBS abroad. MBBS in Uzbekistan 2022-23 is one of the commendable choices for Indian students to practice medicine abroad. Studying in medical colleges of Uzbekistan gives a more excellent calibre of training, regional pathology, learning diagnostics, taking care of the patients, practising medical care and some more."
                },
                "brief":{
                    "capital":"Moscow",
                    "population":"14.41 crore(2020)",
                    "medium":"English",
                    "currency":"Russian Ruble(1 lari=1.37 inr)",
                    "currency_short":"ruble",
                    "in_airport":"Moscow",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"15-20 lakhs (Approx)",
                    "intake":"October",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":""
                },

                "table":{
                    "tution_fee":"3,23,600",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "5 years of total academic term",
                    "1 year of internship at renowned hospitals those are affiliated to individual university. (There are some universities which offers 3 years of internships)",
                    "Five valuable years of your academics in MBBS abroad Ukraine gives you the right amount of exposure."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Process of admissions in Medical universities in Ukraine usually starts after the entrance exams",
                    "Classes of MBBS study in Ukraine starts from the first week of September.",
                    "There are limited seats available in MBBS universities in Ukraine as the students apply from all over the world.",
                    "The seats are specified based on first come first serve.",
                    "Most students make their minds after the entrance exam. It is better to apply in the middle of July or August to get into Top 10 medical colleges in Ukraine.",
                    "We suggest you to gather knowledge about the NMC approved list of Ukrainian universities on their website. You can always enquire your questions in their official chat support."
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets"
                ],
            },
            {
                "id": "117",
                "backgroundurl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Berlin-Mitte_Bebelplatz1_05-2014.jpg/533px-Berlin-Mitte_Bebelplatz1_05-2014.jpg",
                "name": "Bukhara State Medical Institute"
            },
            {
                "id": "118",
                "backgroundurl": "https://a.travel-assets.com/findyours-php/viewfinder/images/res70/346000/346837-Universitatsbibliothek.jpg",
                "name": "Fergana State Medical University"
            },
            {
                "id": "119",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Samarkand State Medical Institute"
            },
            {
                "id": "120",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Tashkent Medical Academy"
            },
            {
                "id": "121",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Tashkent Medical Academy Urgench"
            }
        ],
        "bangladesh": [
            {
                "id": "122",
                "country":"Bangladesh",
                "backgroundurl": "https://www.riaoverseas.com/wp-content/uploads/2020/02/334481852jalalabad.jpg",
                "name": "Jalalabd Ragib Rabeya Medical College",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "Bangladesh officially the People's Republic of Bangladesh, is a country in South Asia. It is the eighth-most-populous country in the world, with a population of around 169 million people in an area of 148,460 square kilometers (57,320 sq mi). Bangladesh is among the most densely populated countries in the world, and shares land borders with India to the west, north, and east, and Myanmar to the southeast; to the south it has a coastline along the Bay of Bengal. It is narrowly separated from Bhutan and Nepal by the Siliguri Corridor; and from China by the Indian state of Sikkim in the north. Dhaka, the capital and largest city, is the nation's political, financial and cultural centre. Chittagong is the busiest port on the Bay of Bengal."
                },
                "brief":{
                    "capital":"Dhaka",
                    "population":"16.94 crores (2021)",
                    "medium":"English",
                    "currency":"Bangladeshi Taka (1 Taka = 0.77 INR)",
                    "currency_short":"Taka",
                    "in_airport":"Moscow",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"20-25 lakhs (Approx)",
                    "intake":"October",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":""
                },
                "table":{
                    "tution_fee":"3,23,600",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "5 years of total academic term",
                    "1 year of internship at renowned hospitals those are affiliated to individual university. (There are some universities which offers 3 years of internships)",
                    "Five valuable years of your academics in MBBS abroad Ukraine gives you the right amount of exposure."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Process of admissions in Medical universities in Ukraine usually starts after the entrance exams",
                    "Classes of MBBS study in Ukraine starts from the first week of September.",
                    "There are limited seats available in MBBS universities in Ukraine as the students apply from all over the world.",
                    "The seats are specified based on first come first serve.",
                    "Most students make their minds after the entrance exam. It is better to apply in the middle of July or August to get into Top 10 medical colleges in Ukraine.",
                    "We suggest you to gather knowledge about the NMC approved list of Ukrainian universities on their website. You can always enquire your questions in their official chat support."
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets"
                ],
            },
            {
                "id": "123",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2023/02/President-Abdul-Hamid-Medical-College.webp",
                "name": "President Abdul Hamid Medical College"
            },
            {
                "id": "124",
                "backgroundurl": "https://cdn-jdkgb.nitrocdn.com/rEIbYQYZFDiRcfEftgjMRmmzODuecuau/assets/images/optimized/rev-e4b369d/wp-content/uploads/2023/05/DCMC-Medical-College-Font-View-1.jpg",
                "name": "Dhaka Community Medical College"
            },
            {
                "id": "125",
                "backgroundurl": "https://www.besonline.in/college_images/ad-din-womens-medical-college-dhaka-bangladesh-fees-structure.jpg",
                "name": "Ad-din Women's Medical College"
            },
            {
                "id": "126",
                "backgroundurl": "https://ad-din.org/wp-content/uploads/2022/12/13.-Ad-din-Sakina-Medical-College-Jashore-started-2011-12.jpg",
                "name": "Ad-din Sakina Women's Medical College"
            },
            {
                "id": "127",
                "backgroundurl": "https://ad-din.org/wp-content/uploads/2022/12/15.-Ad-din-Akij-Medical-College-started-in-Khulna-2015-16.jpg",
                "name": "Ad-din Akij Medical College"
            },
            {
                "id": "128",
                "backgroundurl": "https://ad-din.org/wp-content/uploads/2022/12/14.-Bashundhara-Ad-din-Medical-College-started-in-Keraniganj-Dhaka-2014-15.jpg",
                "name": "Bashundhara Ad-din Medical College"
            },
            {
                "id": "129",
                "backgroundurl": "https://www.besonline.in/college_images/m-h-samorita-medical-college-dhaka-bangladesh-placements.jpg",
                "name": "MH Shamarita Medical College"
            },
            {
                "id": "130",
                "backgroundurl": "https://www.riaoverseas.com/wp-content/uploads/2020/02/887006306PMC.jpg",
                "name": "Popular Medical College"
            },
            {
                "id": "131",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/01/dhaka-national-medical-college.webp",
                "name": "Dhaka National Medical College"
            },
            {
                "id": "132",
                "backgroundurl": "https://admissionroute.com/wp-content/uploads/2022/03/HOLY-FAMILY-RED-CRESCENT-MEDICAL-COLLEGE-1024x768.jpeg",
                "name": "Holy Family Red Crescent Medical College"
            },
            {
                "id": "133",
                "backgroundurl": "https://argroupofeducation.com/wp-content/uploads/2023/10/1-cen.jpg",
                "name": "Central Medical College"
            },
            {
                "id": "134",
                "backgroundurl": "https://www.collegepandit.com/college_img/94.jpg",
                "name": "US-Bangla Medical College"
            },
            {
                "id": "135",
                "backgroundurl": "https://www.careermarg.in/uploads/college-image/1655294586-ibn-sina-medical-college-ismc-dhaka-dhaka.jpg",
                "name": "IBN-Sina Medical College"
            },
            {
                "id": "136",
                "backgroundurl": "https://admissionroute.com/wp-content/uploads/2023/11/North-East-Medical-College.webp",
                "name": "North East Medical College"
            },
            {
                "id": "137",
                "backgroundurl": "https://www.moksh16.com/uploads/images/bengal-medical-college-sushrutanagar-3.webp",
                "name": "North Bengal Medical College"
            },
            {
                "id": "138",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Jaharul lshlam Medical College"
            },
            {
                "id": "139",
                "backgroundurl": "https://admissionroute.com/wp-content/uploads/2022/03/jahurul-islam-medical-college-..jpg",
                "name": "Bangladesh Medical College"
            },
            {
                "id": "140",
                "backgroundurl": "https://www.edufever.com/wp-content/uploads/2021/12/Tbilisi-State-Medical-University-2-jpg.webp",
                "name": "Tbilisi State Medical University"
            },
            {
                "id": "141",
                "backgroundurl": "https://www.besonline.in/college_images/bgc-trust-medical-college-chittagong-bangladesh-facilities.jpg",
                "name": "BGC Trust Medical College"
            },
            {
                "id": "142",
                "backgroundurl": "https://cimchbd.com/public/tenis/images/college.jpg",
                "name": "City Medical College"
            },
            {
                "id": "143",
                "backgroundurl": "https://lh3.googleusercontent.com/proxy/WEndhevTxlH2sj3yiMkqtvGbxffbhsOLS03Y48OWyaCMNyNEw__2poCw1HgDm3PDcUMijB0-ytvz94AOUSXOMFZfYiVEe7SxlZMZGzVDchWGLXmPvYejWLibCLYjPnvXnPcGoPoF8hHh9lYLu9qNsZXGse3S6E0",
                "name": "Enam Medical College"
            },
            {
                "id": "144",
                "backgroundurl": "https://www.saraswationline.com/assets/img/gallery/bangladesh/Anwer%20Khan%20Modern%20Medical%20College/AKMMC-1.jpg",
                "name": "Anwer Khan Medical Colege"
            },
            {
                "id": "145",
                "backgroundurl": "https://admissionroute.com/wp-content/uploads/2022/03/Dhaka-Central-International-Medical-College.jpg",
                "name": "Dhaka Central Medical College"
            },
            {
                "id": "146",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/12/parkview-medical-college-bangladesh-banner.jpg",
                "name": "Park View Medical College"
            },
            {
                "id": "147",
                "backgroundurl": "https://upload.wikimedia.org/wikipedia/commons/e/ec/Sylhet_Women%27s_Medical_College.jpg",
                "name": "SylhetWomen's Medical College"
            },
            {
                "id": "148",
                "backgroundurl": "https://studypalacehub.com/wp-content/uploads/2022/10/b12.jpg",
                "name": "Rangpur Community Medical College"
            },
            {
                "id": "149",
                "backgroundurl": "https://lh3.googleusercontent.com/proxy/hqO9n28Trq_39atxfIurC05ke3ZH_W460ERJN7hUc0hSR90a_4h8Iz7RY2JNp-N0xnjsVUxpeRjU8ZWyoHPBNZkYpk2vTA01fO5AYnOkIPchcQ",
                "name": "Mono Medical College"
            }

        ],
        "armenia": [
            {
                "id": "150",
                "country":"Armenia",
                "backgroundurl": "https://images.collegedunia.com/public/college_data/images/studyabroad/appImage/college_690_14-16:11_cov.jpeg?h=185&w=375&mode=stretch",
                "name": "Armenian Medical Institute",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "Studying MBBS in Armenia is a great option for international students looking for an affordable and high-quality education. Armenia has a number of well-respected medical universities that offer MBBS programs taught in English. The tuition fees for MBBS in Armenia are much lower than the cost of studying MBBS in many other countries.The quality of education in Armenia is also very good. The medical universities in Armenia are accredited by the World Health Organization (WHO) and the European Union (EU). This means that MBBS degrees from Armenia are recognized by many countries around the world."
                },
                "brief":{
                    "capital":	"Tashkent",
                    "population":"27.9 lakhs(2021)",
                    "medium":"English",
                    "currency":"Armenian Dram",
                    "currency_short":"Dram",
                    "in_airport":"Zvartnots",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"25-50 lakhs(Approx)",
                    "intake":"October",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":"Yes"
                },
                "table":{
                    "tution_fee":"3,23,600",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "5 years of total academic term",
                    "1 year of internship at renowned hospitals those are affiliated to individual university. (There are some universities which offers 3 years of internships)",
                    "Five valuable years of your academics in MBBS abroad Ukraine gives you the right amount of exposure."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Process of admissions in Medical universities in Ukraine usually starts after the entrance exams",
                    "Classes of MBBS study in Ukraine starts from the first week of September.",
                    "There are limited seats available in MBBS universities in Ukraine as the students apply from all over the world.",
                    "The seats are specified based on first come first serve.",
                    "Most students make their minds after the entrance exam. It is better to apply in the middle of July or August to get into Top 10 medical colleges in Ukraine.",
                    "We suggest you to gather knowledge about the NMC approved list of Ukrainian universities on their website. You can always enquire your questions in their official chat support."
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets"
                ],
            },
            {
                "id": "151",
                "backgroundurl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Berlin-Mitte_Bebelplatz1_05-2014.jpg/533px-Berlin-Mitte_Bebelplatz1_05-2014.jpg",
                "name": "Mkhitar Gosh Armenian-Russian International University"
            },
            {
                "id": "152",
                "backgroundurl": "https://a.travel-assets.com/findyours-php/viewfinder/images/res70/346000/346837-Universitatsbibliothek.jpg",
                "name": "ST. Tereza Medical University"
            },
            {
                "id": "153",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "University of Traditional Medicine"
            },
            {
                "id": "154",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Yerevan Haybusak University"
            },
            {
                "id": "155",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "Yerevan State Medical University"
            }
        ],
        "belarus": [
            {
                "id": "156",
                "country":"Belarus",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/01/Vitebsk-State-Medical-University.webp",
                "name": " Vitebsk State Medical University",
                "header": {
                    "title": "MBBS IN RUSSIA: Top Medical Universities, Fees Structure, Admission",
                    "shordesp": "Belarus is one of the most considered places for Indian students who want to study MBBS because Belarus medical colleges and university are considered one of the best. The country's literacy is 99.97%. Students worldwide choose to do MBBS in Belarus because of the quality education Belarus provides and with high tech machines. MBBS in Belarus fees is low, and MBBS admission in Belarus is easy, and Belarus comes in one of the world's top safest countries, so MBBS in Belarus is best for Indian students. Most of the MBBS colleges in Belarus are listed in top medical commissions in the world like WHO and MCI ( national medical commission now). It is best to study MBBS in Belarus."
                },
                "brief":{
                    "capital":"Minsk ",
                    "population":"14.41 crore(2020)",
                    "medium":"English",
                    "currency":"Russian Ruble(1 lari=1.37 inr)",
                    "currency_short":"ruble",
                    "in_airport":"Minsk ",
                    "recognition":"NMC (MCI), WHO, ECFMG, FAIMER, WDOMS",
                    "duration":"6 Year (5 + 1 Year's Internship)",
                    "cost_of_stay":"20-25 lakhs (Approx)",
                    "intake":"October",
                    "score_required":"50% in PCB",
                    "hostel":"200 to 260 USD Per Month",
                    "neet_req":"Yes"
                },
                "table":{
                    "tution_fee":"3,23,600",
                    "hostal_fee":"35,000",
                    "otc":"2500$",
                    "incentive":"1200$"
                },
                "duration":[
                    "5 years of total academic term",
                    "1 year of internship at renowned hospitals those are affiliated to individual university. (There are some universities which offers 3 years of internships)",
                    "Five valuable years of your academics in MBBS abroad Ukraine gives you the right amount of exposure."
                ],
                "medium_teaching":[
                    "Having more than thousands of medical students from different parts of the world in Ukraine.",
                    "English being the global language helps students and professors to connect and communicate."
                ],
                "intake":[
                    "Process of admissions in Medical universities in Ukraine usually starts after the entrance exams",
                    "Classes of MBBS study in Ukraine starts from the first week of September.",
                    "There are limited seats available in MBBS universities in Ukraine as the students apply from all over the world.",
                    "The seats are specified based on first come first serve.",
                    "Most students make their minds after the entrance exam. It is better to apply in the middle of July or August to get into Top 10 medical colleges in Ukraine.",
                    "We suggest you to gather knowledge about the NMC approved list of Ukrainian universities on their website. You can always enquire your questions in their official chat support."
                ],
                "eligibility":[
                    "Aspiring students must be above 17+ years minimum and below 25 years as of on 31st December in the year of the admission.",
                    "Student must be from a science background in 10+2",
                    "He/she must have physics, biology, chemistry, and English as main subjects in 10+2",
                    "Students must at least have 50% or more. (40-45% for SC/ST/OBC)",
                    "Must not be from any open school.",
                    "Must qualify the NEET entrance exam to be eligible for MBBS studies in Ukraine."
                ],
                "documents":[
                    "Birth certificate",
                    "10th and 12th mark sheet (Scanned or softcopy)",
                    "Migration certificate",
                    "Bank statement of parents to know if you can afford the university’s tuition fees",
                    "Significant Passport",
                    "Student visa",
                    "Medical Reports",
                    "Passport size photos",
                    "Offer letter from the college where you got seat",
                    "Scanned or soft copy of your NEET scorecard.",
                    "Flight tickets"
                ],
            },
            {
                "id": "157",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/01/Gomel-State-Medical-University-1.webp",
                "name": "Gomel State Medical University"
            },
            {
                "id": "158",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/01/Belarusian-State-Medical-University-2.webp",
                "name": "Belarusian State Medical University"
            },
            {
                "id": "159",
                "backgroundurl": "https://www.ruseducation.in/wp-content/uploads/2022/01/grodno-state-medical-university.webp",
                "name": "Grodno State Medical University"
            }
        ],
        "default": [
            {
                "id": "1",
                "backgroundurl": "https://images.collegedunia.com/public/college_data/images/studyabroad/appImage/college_690_14-16:11_cov.jpeg?h=185&w=375&mode=stretch",
                "name": "abc"
            },
            {
                "id": "2",
                "backgroundurl": "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Berlin-Mitte_Bebelplatz1_05-2014.jpg/533px-Berlin-Mitte_Bebelplatz1_05-2014.jpg",
                "name": "def"
            },
            {
                "id": "3",
                "backgroundurl": "https://a.travel-assets.com/findyours-php/viewfinder/images/res70/346000/346837-Universitatsbibliothek.jpg",
                "name": "ijk"
            },
            {
                "id": "4",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "lmno"
            },
            {
                "id": "5",
                "backgroundurl": "https://www.fu-berlin.de/en/sites/nachhaltigkeit/_media/karussell/Holzelaube-fuer-web.jpg?width=500",
                "name": "lmno"
            }
        ],

    }

}


export default DbData;  